import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import './style.scss';

const Faqs = ({ title, faqs }) => (

    <section className="faqs">
        <h2><I18n k={'search_perseus.seo_sub_category.faqs.title'} params={{ sub_category_title: title }}/></h2>
        <ul>
            {faqs.map((content, index) => (
                <li key={index}>
                    <h3>{content.question}</h3>
                    <p>{content.answer}</p>
                </li>
            ))}
        </ul>
    </section>
);

Faqs.propTypes = {
    title: PropTypes.string,
    faqs: PropTypes.array
};

Faqs.defaultProps = {
    title: '',
    faqs: []
};

export default Faqs;
